<template>
    <div>
        <form>
            <div class="form-group row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p>Su factura ser&aacute; emitida al correo electr&oacute;nico: <b class="text-orange">{{cliente.email}}</b> </p>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                    <router-link tag="button" :to="{ name: 'SearchClient' }" class="btn btn-secondary btn-block btn-lg">
                        <b>Anterior</b>
                    </router-link>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <button class="btn btn-orange btn-block btn-lg" :disabled="disbleBtnCreate" @click="confirmCreateInvoice">
                        <b>
                            <b-icon icon="check-circle"></b-icon>
                            Facturar
                        </b>
                    </button>
                </div>
            </div>
        </form>
        <hr>
        <div class="row">
            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <p>
                    <b>{{cliente.rfc}}</b> <br>
                    <b>{{cliente.nomcli}}</b> <br>
                    <b>C&oacute;digo Postal:</b> {{cliente.cp}}<br>
                    <b>Reg&iacute;men Fiscal:</b> {{regimenFiscal}}<br><br>
                    <b>Uso de CFDI:</b> {{usoCFDI}}<br>
                    <b>Forma de Pago:</b> {{formaPago}}<br>
                    <b>M&eacute;todo de Pago:</b>
                    <span v-if="nota.metodopagosat == 'PUE'"> PUE - Pago en una sola exhibición</span>
                    <span v-if="nota.metodopagosat == 'PPD'"> PPD - Pago en parcialidades o diferido</span>
                </p>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 align-self-center">
                <table class="table table-sm table-borderless">
                    <tr>
                        <td>Importe</td>
                        <td class="border text-right">${{nota.importe | money}}</td>
                    </tr>
                    <tr v-if="nota.descuento > 0">
                        <td>Descuento</td>
                        <td class="border text-right">${{nota.descuento | money}}</td>
                    </tr>
                    <tr v-if="nota.descuento > 0">
                        <td>SubTotal</td>
                        <td class="border text-right">${{nota.subtotal | money}}</td>
                    </tr>
                    <tr>
                        <td>IVA</td>
                        <td class="border text-right">${{nota.impuesto1 | money}}</td>
                    </tr>
                    <tr v-if="nota.impuesto2 > 0">
                        <td>IEPS</td>
                        <td class="border text-right">${{nota.impuesto2 | money}}</td>
                    </tr>
                    <tr>
                        <td><b>Total</b></td>
                        <td class="border text-right"><b>${{nota.total | money}}</b></td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <b-table responsive striped :fields="fields" :items="nota.items" thead-class="bg-navi text-white">
                    <!-- Pje Desc-->
                    <template v-slot:cell(pjedesc)="row">
                        {{row.value}}%
                    </template>
                    <!-- / Pje Desc-->
                    <!-- Pje IVA-->
                    <template v-slot:cell(impuesto1)="row">
                        {{row.value}}%
                    </template>
                    <!-- / Pje IVA-->
                    <!-- Pje Ieps-->
                    <template v-slot:cell(impuesto2)="row">
                        {{row.value}}%
                    </template>
                    <!-- / Pje Ieps-->
                    <!-- Precio Unit-->
                    <template v-slot:cell(precio)="row">
                        ${{row.value | money}}
                    </template>
                    <!-- / Precio Unit-->
                    <!-- Importe-->
                    <template v-slot:cell(importe)="row">
                        ${{row.value | money}}
                    </template>
                    <!-- / Importe-->
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
    import {session} from "@/utils/session"

    export default {
        name: 'Invoice',
        data() {
            return {
                disbleBtnCreate: false,
                fields: [
                    {key: 'cant', label: 'Cantidad'},
                    {key: 'desc', label: 'Descripción'},
                    {key: 'unidad', label: 'Unidad'},
                    {key: 'pjedesc', label: 'Pje Desc', class: 'text-right'},
                    {key: 'impuesto1', label: 'Pje IVA', class: 'text-right'},
                    {key: 'impuesto2', label: 'Pje Ieps', class: 'text-right'},
                    {key: 'precio', label: 'Precio Unit', class: 'text-right'},
                    {key: 'importe', label: 'Importe', class: 'text-right'},
                ],
                nota: {
                    tipodoc: "",
                    numdoc: "",
                    formapagosat: "",
                    metodopagosat: "",
                    fecha: "",
                    hora: "",
                    divisa: "",
                    tc: 0,
                    importe: 0.00,
                    descuento: 0,
                    impuesto1: 0,
                    impuesto2: 0,
                    total: 0,
                    items: []
                },
                cliente: {
                    rfc: "",
                    numcli: "",
                    nomcli: "",
                    cp: "",
                    regimen: "",
                    uso: "",
                    email: "",
                },
                regimenFiscalList: [
                    {id: '601', desc: '601	- General de Ley Personas Morales'},
                    {id: '603', desc: '603	- Personas Morales con Fines no Lucrativos'},
                    {id: '605', desc: '605	- Sueldos y Salarios e Ingresos Asimilados a Salarios'},
                    {id: '606', desc: '606	- Arrendamiento'},
                    {id: '607', desc: '607	- Régimen de Enajenación o Adquisición de Bienes'},
                    {id: '608', desc: '608	- Demás ingresos'},
                    {id: '609', desc: '609	- Consolidación'},
                    {id: '610', desc: '610	- Residentes en el Extranjero sin Establecimiento Permanente en México'},
                    {id: '611', desc: '611	- Ingresos por Dividendos (socios y accionistas)'},
                    {id: '612', desc: '612	- Personas Físicas con Actividades Empresariales y Profesionales'},
                    {id: '614', desc: '614	- Ingresos por intereses'},
                    {id: '615', desc: '615	- Régimen de los ingresos por obtención de premios'},
                    {id: '616', desc: '616	- Sin obligaciones fiscales'},
                    {id: '620', desc: '620	- Sociedades Cooperativas de Producción que optan por diferir sus ingresos'},
                    {id: '621', desc: '621	- Incorporación Fiscal (RIF)'},
                    {id: '622', desc: '622	- Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras'},
                    {id: '623', desc: '623	- Opcional para Grupos de Sociedades'},
                    {id: '624', desc: '624	- Coordinados'},
                    {id: '625', desc: '625	- Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas'},
                    {id: '626', desc: '626	- Régimen Simplificado de Confianza'},
                    {id: '628', desc: '628	- Hidrocarburos'},
                    {id: '629', desc: '629	- De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales'},
                    {id: '630', desc: '630	- Enajenación de acciones en bolsa de valores'},
                ],

                usoCfdiList: [
                    {id: 'G01', desc: 'G01 - Adquisición de mercancias'},
                    {id: 'G02', desc: 'G02 - Devoluciones, descuentos o bonificaciones '},
                    {id: 'G03', desc: 'G03 - Gastos en general'},
                    {id: 'I01', desc: 'I01 - Construcciones'},
                    {id: 'I02', desc: 'I02 - Mobilario y equipo de oficina por inversiones '},
                    {id: 'I03', desc: 'I03 - Equipo de transporte'},
                    {id: 'I04', desc: 'I04 - Equipo de computo y accesorios'},
                    {id: 'I05', desc: 'I05 - Dados, troqueles, moldes, matrices y herramental '},
                    {id: 'I06', desc: 'I06 - Comunicaciones telefónicas'},
                    {id: 'I07', desc: 'I07 - Comunicaciones satelitales'},
                    {id: 'I08', desc: 'I08 - Otra maquinaria y equipo'},
                    {id: 'D01', desc: 'D01 - Honorarios médicos, dentales y gastos hospitalarios. '},
                    {id: 'D02', desc: 'D02 - Gastos médicos por incapacidad o discapacidad '},
                    {id: 'D03', desc: 'D03 - Gastos funerales.'},
                    {id: 'D04', desc: 'D04 - Donativos.'},
                    {
                        id: 'D05',
                        desc: 'D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).'
                    },
                    {id: 'D06', desc: 'D06 - Aportaciones voluntarias al SAR.'},
                    {id: 'D07', desc: 'D07 - Primas por seguros de gastos médicos.'},
                    {id: 'D08', desc: 'D08 - Gastos de transportación escolar obligatoria. '},
                    {
                        id: 'D09',
                        desc: 'D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones. '
                    },
                    {id: 'D10', desc: 'D10 - Pagos por servicios educativos (colegiaturas) '},
                    {id: 'S01', desc: 'S01 - Sin efectos fiscales'},
                    {id: 'P01', desc: 'P01 - Por definir'}
                ],

                formaPagoList: [
                    {id: '01', desc: '01 - Efectivo'},
                    {id: '02', desc: '02 - Cheque nominativo'},
                    {id: '03', desc: '03 - Transferencia electrónica de fondos'},
                    {id: '04', desc: '04 - Tarjeta de crédito'},
                    {id: '05', desc: '05 - Monedero electrónico'},
                    {id: '06', desc: '06 - Dinero electrónico'},
                    {id: '08', desc: '08 - Vales de despensa'},
                    {id: '12', desc: '12 - Dación en pago'},
                    {id: '13', desc: '13 - Pago por subrogación'},
                    {id: '14', desc: '14 - Pago por consignación'},
                    {id: '15', desc: '15 - Condonación'},
                    {id: '17', desc: '17 - Compensación'},
                    {id: '23', desc: '23 - Novación'},
                    {id: '24', desc: '24 - Confusión'},
                    {id: '25', desc: '25 - Remisión de deuda'},
                    {id: '26', desc: '26 - Prescripción o caducidad'},
                    {id: '27', desc: '27 - A satisfacción del acreedor'},
                    {id: '28', desc: '28 - Tarjeta de débito'},
                    {id: '29', desc: '29 - Tarjeta de servicios'},
                    {id: '30', desc: '30 - Aplicación de anticipos'},
                    {id: '31', desc: '31 - Intermediario pagos'},
                    {id: '99', desc: '99 - Por definir'}
                ],
            }
        },
        mounted() {
            if (session.getValue("nota") && session.getValue("cliente")) {
                this.nota = session.getValue("nota");
                this.cliente = session.getValue("cliente");
            } else {
                if (!session.getValue("nota")) {
                    this.$router.push({name: 'SearchNote'})
                } else {
                    this.$router.push({name: 'SearchClient'})
                }
            }

        },
        computed: {
            regimenFiscal(){
                if (this.cliente.regimen.trim() !== "") {
                    let regimen = this.regimenFiscalList.find(item => item.id === this.cliente.regimen);
                    return regimen.desc
                }
                return ""
            },
            usoCFDI() {
                if (this.cliente.uso.trim() !== "") {
                    let uso = this.usoCfdiList.find(item => item.id === this.cliente.uso);
                    return uso.desc
                }
                return ""
            },
            formaPago() {
                if (this.nota.formapagosat.trim() !== "") {
                    let forma = this.formaPagoList.find(item => item.id === this.nota.formapagosat);
                    return forma.desc
                }
                return ""
            }
        },
        methods: {
            confirmCreateInvoice(e) {
                e.preventDefault();
                this.$bvModal.msgBoxConfirm('¿Está seguro que desea facturar?', {
                    title: 'Facturar',
                    size: 'sm',
                    buttonSize: 'sm',
                    okTitle: 'Facturar',
                    cancelTitle: 'Cancelar',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }).then(value => {
                    if (value) {
                        this.createInvoice();
                    }
                });
            },

            createInvoice() {
                this.disbleBtnCreate = true;
                let data = {};
                data.email = this.cliente.email;
                data.usocfdi = this.cliente.uso;
                data.numcli = this.cliente.numcli;
                data.rfc = this.cliente.rfc;
                data.nombre = this.cliente.nomcli;
                data.cp = this.cliente.cp;
                data.idregimen = this.cliente.regimen;

                this.$store.dispatch('invoice/add', data)
                    .then(res => {
                        this.$router.push({name: 'Thanks', params: {...res.data.result, email: this.cliente.email}})
                    })
                    .catch(err => {
                        this.disbleBtnCreate = false;
                        this.showAlertErrors(err);
                    });
  
            },

            showAlertErrors(err) {
                let msgErr = "";
                if (err.response.data.error) {
                    this.msgAlert("Error: " + JSON.parse(err.response.data.error).msg);
                    console.log(err.response.data.error);
                    return
                }

                if (err.response.data.validations) {
                    err.response.data.validations.forEach((item) => {
                        msgErr += " -" + item.error + "\n"
                    });
                    this.msgAlert("Advertencia:\n " + msgErr);
                    console.log(err.response.data.validations);
                    return
                }

                if (err.response.data.permissions) {
                    err.response.data.permissions.forEach((item) =>{
                        msgErr += " -" + item.desc + "\n"
                    });
                    this.msgAlert("Necesita permisos de:\n " + msgErr);
                    console.log(err.response.data.permissions);
                    return
                }

            },

            msgAlert(err) {
                this.$bvModal.msgBoxOk(err, {
                    title: 'Ocurrió un problema al facturar',
                    size: 'md',
                    buttonSize: 'md',
                    okVariant: 'primary',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                });
            },
        }
    }
</script>

<style>
    .table .thead-navi th {
        color: #fff;
        background-color: #1a2a3c;
        border-color: #1a2a3c;
    }
</style>